import React, { useContext } from "react";
import GroupContext from "../../context/group";

const FormCheckbox = ({ id, field, children, isRequired, ...other }) => {
  const { formData, onChange, formErrors } = useContext(GroupContext);
  return (
    <div className="form__checkbox position-relative">
      <input
        type="checkbox"
        name={field}
        checked={formData[field]}
        value="1"
        id={id}
        onChange={onChange}
        data-required={isRequired}
        {...other}
      />
      <label className="form__checkbox-label" htmlFor={id}>
        {children}
      </label>
      {formErrors[field] && (
        <span className="form__error-message d-inline">{formErrors[field]}</span>
      )}
    </div>
  );
};

export default FormCheckbox;
